import { RoutesFactory } from '@holdingblachere/vue-shop-auth-plugin';
import { RoutesFactory as AuthRoutesFactory } from '@holdingblachere/vue-auth-plugin';

const authRoutes = AuthRoutesFactory.CreateRoutes();

// This fix allows to leverage the shopAuthGuard and authGuard.
// When you go to the Home page, if your shop is authenticated, you're redirected to login route.
// When you go to the Login route, if your user is authenticated,
// you're redirected to your dashboard.
authRoutes[0].meta = {
  shopGuestRequired: true,
};

authRoutes[1].meta = {
  userGuestRequired: true,
};

const routes = [
  ...RoutesFactory.CreateShopLoginRoutes(),
  ...authRoutes,
  // Full Page Layout
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage.vue'),
    children: [
      {
        path: '/oidc/login',
        name: 'OidcLogin',
        component: () => import('@/views/pages/Oidc/Login.vue'),
        props: (route) => {
          const acrValues = {};
          route.query.acr_values.split('=').forEach((e, index, arr) => {
            if (index % 2 === 1) {
              acrValues[arr[index - 1]] = e;
            }
          });
          return {
            responseType: route.query.response_type,
            clientId: route.query.client_id,
            redirectUri: route.query.redirect_uri,
            scope: route.query.scope,
            state: route.query.state,
            codeChallenge: route.query.code_challenge,
            acrValues,
          };
        },
      },
      {
        path: '/choix-utilisateur',
        name: 'Login',
        component: () => import('@/views/pages/UserLoginPage/Index.vue'),
        props: true,
        meta: {
          shopAuthRequired: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout.vue'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout.vue'),
    redirect: { name: 'Profile' },
    children: [
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        meta: { auth: true },
        props: {
          pageTitle: 'Mon profil',
        },
      },
      {
        path: '/profil-utilisateur',
        name: 'UserProfile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        props: (route) => ({
          userId: route.query.id,
          pageTitle: 'Profil utilisateur',
        }),
        meta: { auth: true },
      },
      {
        path: '/gestion-personnel',
        name: 'ManageUsers',
        component: () => import('@/views/pages/ManageUsersPage/Index.vue'),
        props: true,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    name: 'Home',
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
